export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/league_of_legends.6efd14e.svg";